import {
  ReportType,
  ReportTypeDisplayName,
  ReportTypeEnum,
} from "pmt-types/src/enums/ReportType.ts";
import { Report } from "pmt-types/src/models/Report.ts";
import { useState } from "react";
import { z } from "zod";
import AddedReportList from "../../components/app/addedReportList.tsx";
import EnumSelect from "../../components/form/enumSelect.tsx";
import PmtForm from "../../components/form/pmtForm.tsx";
import FormRoot from "../../components/form/style/formRoot.tsx";
import FormSection from "../../components/form/style/formSection.tsx";
import { Maybe } from "../../utils/types/maybe.ts";
import BidDeductReportForm from "./bidDeductReportForm.tsx";
import EnrollmentStatusBidCreditReportForm from "./enrollmentStatusBidCreditReportForm.tsx";
import EnrollmentStatusTierReportForm from "./enrollmentStatusTierReportForm.tsx";

const ReportTypeFormSchema = z.object({
  reportType: ReportType.optional(),
});

type ReportTypeForm = z.infer<typeof ReportTypeFormSchema>;

export default function AddReport() {
  const [reportType, setReportType] = useState<Maybe<ReportTypeEnum>>(null);
  const [addedReports, setAddedReports] = useState<Report[]>([]);

  let reportParamsForm = <></>;
  switch (reportType) {
    case ReportType.enum.EnrollmentStatusBidCredit:
      reportParamsForm = (
        <EnrollmentStatusBidCreditReportForm
          onAddReport={(report) => {
            setAddedReports((current) => [report, ...current]);
          }}
        />
      );
      break;
    case ReportType.enum.EnrollmentStatusTier:
      reportParamsForm = (
        <EnrollmentStatusTierReportForm
          onAddReport={(report) => {
            setAddedReports((current) => [report, ...current]);
          }}
        />
      );
      break;
    case ReportType.enum.BidDeduct:
      reportParamsForm = (
        <BidDeductReportForm
          onAddReport={(report) => {
            setAddedReports((current) => [report, ...current]);
          }}
        />
      );
      break;
  }

  return (
    <>
      <PmtForm<ReportTypeForm>
        schema={ReportTypeFormSchema}
        pageTitle={"Build Report"}
        formStyle={"no-submit"}
        isSubmitting={false}
        onSave={() => {}}
        onCancel={() => {}}
        renderForm={({ watch }) => {
          watch((value) => {
            setReportType(value.reportType);
          });

          return (
            <FormRoot>
              <FormSection>
                <EnumSelect
                  name="reportType"
                  label="Report Type"
                  data={ReportType.options}
                  formatOption={(option) =>
                    ReportTypeDisplayName[option as ReportTypeEnum]
                  }
                />
              </FormSection>
            </FormRoot>
          );
        }}
      />
      {reportParamsForm}
      {addedReports != null && addedReports.length != 0 && (
        <AddedReportList reports={addedReports} />
      )}
    </>
  );
}
